// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1391":"f4011f1c7a41fcfe","2881":"f9700d679176d693","2950":"be91e0b0b01bca60","5462":"d024b6479c1d6d34","7055":"d7c97e136d80cd28","8963":"e8d6e72a6f8dcac5"}[chunkId] + ".css";
};